import { useEffect, useState } from "react";
import { Link2, X } from "lucide-react";
import { api } from "@/lib/api";

const DISMISS_KEY = "snaplist.connectEbayDismissed";

export default function ConnectEbayBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { if (sessionStorage.getItem(DISMISS_KEY)) return; } catch { /* ignore */ }
    const check = () => api.get("/ebay/status", { swr: true }).then(({ data }) => setShow(!data?.connected)).catch(() => {});
    check();
    window.addEventListener("focus", check);
    return () => window.removeEventListener("focus", check);
  }, []);

  if (!show) return null;
  const openSettings = () => document.querySelector('[data-testid="open-ebay-settings"]')?.click();
  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ }
    setShow(false);
  };

  return (
    <div className="mb-5 flex flex-wrap items-center gap-3 rounded-xl border border-[#0053DA]/20 bg-[#0053DA]/5 px-4 py-3" data-testid="connect-ebay-banner">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#0053DA] text-white">
        <Link2 className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-slate-900">Connect your eBay account</p>
        <p className="text-xs text-slate-600">Sign in to eBay once so SnapList can publish your drafts as real listings.</p>
      </div>
      <button type="button" onClick={openSettings} data-testid="connect-ebay-banner-btn"
        className="rounded-full bg-[#0053DA] px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-[#0043B0]">
        Connect eBay
      </button>
      <button type="button" onClick={dismiss} aria-label="Dismiss" data-testid="connect-ebay-banner-dismiss"
        className="rounded-md p-1 text-slate-400 hover:bg-white hover:text-slate-700">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
